module.exports = __webpack_public_path__ + "img/blood-pressure-log_B09M59HXGH.d39d3a8c.jpg";